$(window).on("load", function(){
  
  $("body").on("click", ".coder-compareder-compare", function(){
    if($(this).hasClass("coder-compare-added")) {
      //$(".btn-compare").removeClass("compare-added");
    }
    else {
      //$(".btn-compare").addClass("compare-added");
    }
  });
  $("body").on("click", ".btn-wishlist", function(){
	$("#ZlistWishlist label").trigger("click");
  });
  $("body").on("mouseenter", ".coder-compareder-compare", function(){
  	$(".btn-compare").addClass("active");	
  });
  $("body").on("mouseleave", ".coder-compareder-compare", function(){
    if(!$(this).hasClass("coder-compare-added")) {
  		$(".btn-compare").removeClass("active");
    }
  });
  if($("body").hasClass("template-product")) {
    
    setInterval(function(){
      if($(".coder-compareder-compare.coder-compare-added").length > 0) {
        $(".btn-compare").addClass("active");
      }
      
      if($(".product-actions .coder-compareder-compare") .length < 1) {
          $(".coder-compareder-compare").prependTo(".product-actions");
      }
    }, 1000);
  }
  if($('.collectionSlider').length > 0 ) {
    $('.collectionSlider').flickity({
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      groupCells: true,
      
    });
  }
  
  $(".boost-pfs-filter-options-wrapper .boost-pfs-filter-option").each(function(){
    var fList = $(this).children().find("ul");
    console.log(fList.children("li").length);
    if(fList.children("li").length == fList.children("li.disabled").length) {
      $(this).css({"display":"none"});
    }
    
  });
  

  
});  